"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AutocompleteModule = void 0;
const base_1 = require("./base");
const util_1 = require("./util");
class AutocompleteModule extends base_1.SelectModule {
    constructor() {
        super(...arguments);
        this._type = "Autocomplete";
    }
    validate() {
        return true;
    }
    toBuilderConfig() {
        if (this.validate()) {
            return {
                actionRequired: this.actionRequired,
                type: this.type,
                id: this.id,
                options: this.options.map((opt) => ({
                    id: opt.id || (0, util_1.generateUUID)(),
                    label: opt.label || { en: "" },
                    hidden: !!opt.hidden,
                })),
                required: this.required,
                label: this.label,
                hidden: this.hidden,
            };
        }
        throw new Error((0, base_1.INVALID_MODULE)(this));
    }
    toSurveyConfig() {
        var _a, _b;
        const { required, label, ...base } = this.toBuilderConfig();
        const surveyConfigModule = {
            ...base,
            actionRequired: this.actionRequired,
            header: { children: (_a = label === null || label === void 0 ? void 0 : label[this.languageCode]) !== null && _a !== void 0 ? _a : "" },
            options: (_b = base.options) === null || _b === void 0 ? void 0 : _b.map((opt) => {
                var _a;
                return ({
                    id: opt.id || (0, util_1.generateUUID)(),
                    label: (_a = opt.label) === null || _a === void 0 ? void 0 : _a[this.languageCode],
                    hidden: !!opt.hidden,
                });
            }),
        };
        if (required) {
            surveyConfigModule.validation = (0, util_1.addRequiredValidation)();
        }
        return surveyConfigModule;
    }
    editProps() {
        var _a;
        return {
            id: this.id,
            options: this.options.map((opt) => {
                var _a;
                return ({
                    id: opt.id || (0, util_1.generateUUID)(),
                    label: (_a = opt.label) === null || _a === void 0 ? void 0 : _a[this.languageCode],
                    hidden: !!opt.hidden,
                });
            }),
            type: this.type,
            question: (_a = this.label[this.languageCode]) !== null && _a !== void 0 ? _a : "",
            actionRequired: this.actionRequired,
            hidden: this.hidden,
        };
    }
}
exports.AutocompleteModule = AutocompleteModule;
//# sourceMappingURL=Autocomplete.js.map